/* Enter your Custom Javascript code below without script tag 

// Company name: Developed by TechFanatic 
// Website URL: https://techfanatic.in/

*/

window.addEventListener('DOMContentLoaded',function () {

    setTimeout(function () {
    $(".m-menu-customer__language-currency").appendTo("ul.m-menu-drawer__navigation.m-menu-mobile");

    }, 1500)
    
  
});